module.exports = __webpack_public_path__ + "media/images/icons/institution-b4fd9b8c2e611964c17b2947aec065f2.svg";